module.exports = __webpack_public_path__ + "static/media/JaspalSabharwal.5f5db0a5.png";